import React from 'react';
import _ from 'lodash';
import Griddle from 'griddle-react';
import {Map} from 'immutable';
import {PermissionRequired, TableSearch} from '../../components';
import {search} from '../../components/TableSearch/TableSearch';
import {ContractsAction} from '../../actions';
import {Activities} from '../../constants';
import {ContractsStore} from '../../stores';

// Module-level: survives route changes within the same browser session, clears on full page refresh.
// Consistent with the _importsStateCache pattern used in ImportsWrapper.js.
let _savedPage = null;

// Called by TopNav when the user explicitly navigates to the imports list via the header,
// so the list always starts at page 1 on a fresh navigation.
export function resetImportsPage() {
  _savedPage = null;
}

export default React.createClass({
  propTypes: {
    contracts:     React.PropTypes.array,
    loadingStatus: React.PropTypes.object
  },

  getDefaultProps: function () {
    return {
      contracts:     [],
      loadingStatus: Map({
        status:  'loading',
        message: 'Fetching data from server. Please wait.',
      })
    }
  },

  getInitialState() {
    return {
      contracts: this.props.contracts
    }
  },

  componentDidMount() {
    // _pageRestored tracks whether we have already called setPage for this mount cycle.
    // We can't restore in componentDidMount because PermissionRequired returns null when
    // user is null, meaning this.refs.griddle doesn't exist yet at that point.
    this._pageRestored = false;
    this._tryRestorePage();
  },

  componentDidUpdate() {
    // Keep trying on every update until griddle is available (user prop gets set asynchronously).
    if (!this._pageRestored) {
      this._tryRestorePage();
    }
  },

  _tryRestorePage() {
    if (!this.refs.griddle) return;
    // Mark done immediately so we only ever restore once per mount cycle.
    this._pageRestored = true;
    if (_savedPage != null && _savedPage > 0) {
      this.refs.griddle.setPage(_savedPage);
    }
    _savedPage = null; // consume after use
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(nextProps.contracts, this.props.contracts)
      || this.props.loadingStatus.get('status') !== nextProps.loadingStatus.get('status');
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchParams.size > 0) {
      let filteredContracts = search([...nextProps.contracts], nextProps.searchParams.toJS())
      this.setState({contracts: filteredContracts})
    } else {
      this.setState({contracts: nextProps.contracts})
    }
    this.forceUpdate();
  },

  componentWillUnmount() {
    // Save the current Griddle page (0-indexed) into the module-level variable
    // so _tryRestorePage can restore it on the next mount.
    if (this.refs.griddle && this.refs.griddle.state) {
      _savedPage = this.refs.griddle.state.page;
    }

    ContractsStore.setState({ search: Map() });
  },

  render() {
    return (
      <PermissionRequired requiredRoles={Activities.READ_CONTRACTS} user={this.props.user}>
        <TableSearch
          user={this.props.user}
          requiredRoles={Activities.WRITE_CONTRACTS}
          columnMetadata={this.props.columnMetadata}
          onSearch={this.handleSearch}
          isImportButton={this.props.isImportButton}
          importButtonText="New import"
          onImport={this.props.onImport}
          searchParams={this.props.searchParams ? this.props.searchParams.toJS() : {}}
        />
        <Griddle
            ref="griddle"
            initialSort="createdAt"
            initialSortAscending={false}
            results={this.state.contracts}
            tableClassName="table middle-td"
            resultsPerPage={20}
            filterPlaceholderText="Search"
            columnMetadata={this.props.columnMetadata}
            columns={this.props.columnNames}
          />
      </PermissionRequired>
    )
  },

  handleSearch(e) {
    let {name, value} = e.target;
    ContractsAction.search(name, value);
  }
});
